import { Link } from 'react-router-dom';

const LAST_UPDATED = 'July 3, 2026';

export function TermsPage() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-12">
      <header className="mb-10 pb-6 border-b border-border">
        <h1 className="font-serif text-3xl font-semibold text-stone-light mb-2">Terms of Service</h1>
        <p className="text-xs text-text-muted uppercase tracking-widest">Last updated {LAST_UPDATED}</p>
      </header>

      <div className="space-y-8 text-sm text-text-secondary leading-relaxed">
        <section className="space-y-3">
          <p>
            Agora Bench is provided by <strong className="text-text-primary">Myro Productions</strong> as a personal project,
            free of charge, for entertainment and education. By using the site you agree to these terms.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="font-serif text-xl text-gold">Provided as-is</h2>
          <p>
            The site is offered <strong className="text-text-primary">"as is," without warranty</strong> of any kind. We do not
            guarantee it will be available, error-free, or accurate. We may change, pause, or shut down the simulation or any
            feature at any time.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="font-serif text-xl text-gold">Governance content is AI-generated fiction</h2>
          <p>
            Everything the simulation produces — bills, laws, debates, votes, elections, parties, and agent statements — is{' '}
            <em>generated by AI and is fiction</em>. It is not factual, not legal or political advice, and does not reflect the
            views of Myro Productions or any real person or organization. Do not rely on any of it as accurate information.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="font-serif text-xl text-gold">Acceptable use</h2>
          <p>Please use the site reasonably. Do not:</p>
          <ul className="list-disc pl-6 space-y-1 marker:text-gold/60">
            <li>Scrape, crawl, or hammer the site in a way that degrades it for others.</li>
            <li>Attempt to attack, disrupt, overload, or gain unauthorized access to the site or its infrastructure.</li>
            <li>Abuse, harass, or misuse any interactive or account features.</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="font-serif text-xl text-gold">Accounts</h2>
          <p>
            If you create an account, you are responsible for activity under it. We may suspend or terminate accounts that abuse
            the site or violate these terms.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="font-serif text-xl text-gold">Changes to these terms</h2>
          <p>
            We may update these terms from time to time. The "last updated" date above reflects the current version. Continued
            use after a change means you accept the updated terms.
          </p>
        </section>

        <section className="pt-4 border-t border-border/40">
          <p className="text-text-muted">
            See also our{' '}
            <Link to="/privacy" className="text-gold hover:text-gold-bright underline underline-offset-2">
              Privacy Policy
            </Link>
            .
          </p>
        </section>
      </div>
    </div>
  );
}
